const stage="training"; 


const gatewayURLs={
  dan: "https://2hxl6suv4g.execute-api.eu-west-2.amazonaws.com/dan",
  dev: "https://l9cj189rh5.execute-api.eu-west-2.amazonaws.com/dev",
  test: "https://a6a56ya2q5.execute-api.eu-west-2.amazonaws.com/test",
  training: "https://zk8tyuqqo6.execute-api.eu-west-2.amazonaws.com/training", 
  production: "https://s4jz7vx0i7.execute-api.eu-west-2.amazonaws.com/production", 
  conradtest: "https://99ku1jzf2g.execute-api.eu-west-2.amazonaws.com/conradtest",
  omnitest: "https://ojnbrbzh1d.execute-api.eu-west-2.amazonaws.com/omnitest",
  omniprod: "https://hb060r1nsi.execute-api.eu-west-2.amazonaws.com/omniprod", 
  conradprod: "https://4lb4uqm5e6.execute-api.eu-west-2.amazonaws.com/conradprod", 
  conraduat: "https://wtt7h2xpsl.execute-api.eu-west-2.amazonaws.com/conraduat", 
  omniuat: "https://t9uamzfzqc.execute-api.eu-west-2.amazonaws.com/omniuat", 
  demo: "https://503ektqy3d.execute-api.eu-west-2.amazonaws.com/demo", 
  radiustest: "https://zx04rxrj0f.execute-api.eu-west-2.amazonaws.com/radiustest",
  unifytest: "https://97n2vwpql3.execute-api.eu-west-2.amazonaws.com/unifytest", 
  radiusprod: "https://hq5o9fnbje.execute-api.eu-west-2.amazonaws.com/radiusprod", 
  unifyprod: "https://1zp1hhvlrc.execute-api.eu-west-2.amazonaws.com/unifyprod", 
  greentest: "https://b0mkf8ovk5.execute-api.eu-west-2.amazonaws.com/greentest",
  greenprod: "https://ruajhxwtd8.execute-api.eu-west-2.amazonaws.com/greenprod",
  dgptest: "https://96yqhmapu6.execute-api.eu-west-2.amazonaws.com/dgptest",
  dgpuat: "https://ghrtbkikw9.execute-api.eu-west-2.amazonaws.com/dgpuat",
  dgpprod: "https://b6kbh5r4y5.execute-api.eu-west-2.amazonaws.com/dgpprod",


};

const smartURLs={
  dan: "https://31b5ik5672.execute-api.eu-west-2.amazonaws.com/dan"
};


const userPoolIds={
  dan: "eu-west-2_kWyJkAJXK",
  dev: "eu-west-2_kWyJkAJXK",
  test: "eu-west-2_kWyJkAJXK",
  smarttest: "eu-west-2_kWyJkAJXK",
  training: "eu-west-2_U1hd34rO5", 
  production: "eu-west-2_mV9Lj7t2T", 
  conradtest: "eu-west-2_UdlHufq9g", 
  omnitest: "eu-west-2_os0xm7TOW", 
  omniprod: "eu-west-2_fhFeoUNzn", 
  conradprod: "eu-west-2_P2aotLbqM", 
  conraduat: "eu-west-2_QKJOdLZzO", 
  omniuat: "eu-west-2_zAqlPDDJT", 
  demo: "eu-west-2_VATSUpeDZ",
  radiustest: "eu-west-2_qSnYpeNSa",
  unifytest: "eu-west-2_tX4LJ5va9", 
  radiusprod: "eu-west-2_8O1l1gOxs", 
  unifyprod: "eu-west-2_ej8IDWRbr", 
  greentest: "eu-west-2_943DXPRqH",
  greenprod: "eu-west-2_wRAtDQY4t",
  dgptest: "eu-west-2_WaPNYZsKR",
  dgpuat: "eu-west-2_HuZTHM1Hu",
  dgpprod: "eu-west-2_TNfJ1F1Iw"
};

const appClientIds={
  dev: "lj9rvmobt48m2lg124j5d0sho",
  dan: "lj9rvmobt48m2lg124j5d0sho",
  test: "lj9rvmobt48m2lg124j5d0sho",
  smarttest: "lj9rvmobt48m2lg124j5d0sho",
  training: "1a05jst02r67oqs779mobt3v4c", 
  production: "4hbtasb3doa2mc2nckj1u9s11e", 
  conradtest: "73ctl2u62rbqsrm4unqsivfb4a", 
  omnitest: "7iafrragmdiunn0koilht53hsn", 
  omniprod: "2pahv5qp6evvhbpfi8gjqmpoqr", 
  conradprod: "65sqrfppv4g2kmk4st9qgcndkj",
  conraduat: "3raes5msi5nlpe05ihsngh0oto", 
  omniuat: "1afasibmi2jcqtu1ieh1k0cmmm", 
  demo: "7lqfrtugkbesjplo04220eqf0t",
  radiustest: "1dnkr0bpjoq0rf6gv3supntuf1",
  unifytest: "3r0afvjqvllru9rei8nkbc92h4", 
  radiusprod: "7065rpael8jlf89rk0tpvpofi3", 
  unifyprod: "7qn1mqnfq8plr26gh61ts695ea", 
  greentest: "5vefeneffb5fub5hj8rmop1omr",
  greenprod: "552es7uqgco9d54r6ufqh6v2fd",
  dgptest: "4tjathumq6okn6vvu8317j3uiu",
  dgpuat: "7fi7u8b2umh6pf28nbae36regf",
  dgpprod: "2s0s9ovgvoqdn961r4467soqgt"
};

const awsEnv={
  dev: "sg",
  dan: "sg",
  test: "sg",
  training: "valda",
  production: "valda", 
  conradtest: "sg", 
  omnitest: "sg", 
  omniprod: "sg", 
  conradprod: "sg", 
  conraduat: "sg", 
  omniuat: "sg", 
  demo: "sg",
  radiustest: "sg", 
  unifytest: "sg", 
  radiusprod: "sg", 
  unifyprod: "sg", 
  greentest: "sg", 
  greenprod: "sg",
  dgptest: "sg",
  dgpuat: "sg",
  dgpprod: "sg"
};

const identityPoolIds={
  dev: "eu-west-2:4f8b16cb-7a2e-4f44-a1f1-d657b4a494b9",
  dan: "eu-west-2:4f8b16cb-7a2e-4f44-a1f1-d657b4a494b9",
  test: "eu-west-2:4f8b16cb-7a2e-4f44-a1f1-d657b4a494b9",
  smarttest: "eu-west-2:4f8b16cb-7a2e-4f44-a1f1-d657b4a494b9",
  training: "eu-west-2:9a93047c-21f6-4d16-a4dd-a0e9b3abe967", 
  production: "eu-west-2:af490153-bdd7-4d34-96d8-9e437f34d62f", 
  conradtest: "eu-west-2:68af4497-ae15-47ac-aa88-5dc352edef45", 
  omnitest: "eu-west-2:e659a7bf-b8fc-4956-b230-dcf9cee88e51", 
  omniprod: "eu-west-2:ebd3661d-8600-41f3-a2c6-0cdcf1f59050", 
  conradprod: "eu-west-2:33d3c1c0-4ed7-45a2-8ddf-e4f509584b27",
  conraduat: "eu-west-2:1c36e85b-4f0d-4afa-a775-4a59d4891368", 
  omniuat: "eu-west-2:c409fa15-e20a-4427-9d24-90a6adf16140", 
  demo: "eu-west-2:0be22033-6661-4bf7-ba7a-b50c9eebc6dd",
  radiustest: "eu-west-2:fef4166c-ffd8-43d3-9d25-0440569c47c6", 
  unifytest: "eu-west-2:e6dbb588-24af-4092-8a00-f0c7f9b17e80", 
  radiusprod: "eu-west-2:26b3b354-dfba-49d3-b0f5-349e3fae6016",
  unifyprod: "eu-west-2:a54034ad-f880-4a2f-a440-241ae9f0e0e0",
  greentest: "eu-west-2:c9fcff0f-13dc-47fd-b880-ef7fafb07c43",
  greenprod: "eu-west-2:2e67f195-3ee9-4b13-baa0-3e28e6a9ea5d",
  dgptest: "eu-west-2:7c39120b-1135-48d5-9c20-56cccd42a289",
  dgpuat: "eu-west-2:91fe2ccd-0baa-45d7-b2af-a9aede74631b",
  dgpprod: "eu-west-2:e7c2ffa7-65c0-400b-9df7-173864830ab1"
};


const productionEnvs=["production", "conradprod", "unifyprod", "greenprod", "dgpprod"]

const smartAdapterS3Buckets={
  dev: "",
  dan: "",
  test: "",
  training: "smartadapter.config.valda.uit",
  production: "smartadapter.config.valda.prod", 
  conradtest: "", 
  omnitest: "", 
  omniprod: "", 
  conradprod: "", 
  conraduat: "", 
  omniuat: "", 
  demo: "",
  radiustest: "", 
  unifytest: "", 
  radiusprod: "", 
  unifyprod: "smartadapter.config.unify.prod", 
  greentest: "", 
  greenprod: "smartadapter.config.green.prod",
  dgptest: "",
  dgpuat: "",
  dgpprod: "smartadapter.config.dgp.prod"

  
  };

export default {
    stage: stage, 
    awsEnv: awsEnv[stage],
    regionalTLMs: true, 
    applicationid: 6, 
    aws: {
      region: 'eu-west-2'
    },     
    cognito: {
      USER_POOL_ID: userPoolIds[stage],
      APP_CLIENT_ID: appClientIds[stage], 
      REGION: "eu-west-2",
      IDENTITY_POOL_ID: identityPoolIds[stage],
    },
    apiGateway: {URL: gatewayURLs[stage], REGION: "eu-west-2"}, 
    smartGateway: {URL: smartURLs[stage], REGION: "eu-west-2"}, 
    idealPostcodes: {
      apiKey: "ak_jdvaylju2IzZSiG2RJn1zDzPeufCB"
    }, 
    production: productionEnvs.indexOf(stage)>-1, 
    smartAdapterS3Bucket: smartAdapterS3Buckets[stage]
  };
